
@if (form && id) {
    <div class="input-group mb-4"
         [formGroup]="form"
         [hidden]="!currencySymbol">
        <span class="input-group-addon" [hidden]="hidePrefix">{{symbolPrefix}}{{currencySymbol}}</span>
        <input type="text" class="form-control"
               [name]="id"
               [required]="isRequired"
               [formControlName]="id"
               (change)="change()"
               [pattern]="currencyPattern"
               (blur)="blur()" />
    </div>
    @if (form.get(id)?.errors?.['pattern']) {
        <div class="alert alert-danger">
            <span [innerHTML]="'SB_Invalid_Amount_Or_Negative' | translate: { maxDecimalPlaces: maxDecimalPlaces }"></span>
        </div>
    }
} @else {
    <div class="input-group mb-4"
         [hidden]="!currencySymbol">
        <span class="input-group-addon" [hidden]="hidePrefix">{{symbolPrefix}}{{currencySymbol}}</span>
        <input type="text" class="form-control"
               [disabled]="isDisabled"
               [name]="id"
               [required]="isRequired"
               [(ngModel)]="model"
               #amountModel="ngModel"
               (change)="change()"
               [pattern]="currencyPattern"
               (blur)="blur()" />
    </div>
    @if (amountModel.errors?.['pattern']) {
        <div class="alert alert-danger">
            <span [innerHTML]="'SB_Invalid_Amount_Or_Negative' | translate: { maxDecimalPlaces: maxDecimalPlaces }"></span>
        </div>
    }
}
<sb-loading [hasLoaded]="currencySymbol !== undefined"></sb-loading>
